import { dispatcher, IEvent, ingenuity } from "@quest/base-core";
import {
  FreeGameMetersControllerBehavior,
  SlotConstantsBehavior,
  SlotEventConstantsBehavior,
} from "@quest/murka-games-behavior-panther/dist";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { GameParserModel } from "../Platform/GameParserModel";

/**
 * MetersControllerGame class handles the meters for the base game
 *  ex. win meter, win tickup etc.
 */
export class FreeGameMetersControllerGame extends FreeGameMetersControllerBehavior {


  /**
   * This method is use to skip cascade animation on stage click
   */
  protected onForceStopWinTickUp(evt?: IEvent): void {
    if (ingenuity.configData.stageClickOnCascade) {
      if (this.winValueMeterFg.getIsTickUpRunning()) {
        this.winValueMeterFg.forceStop((ingenuity.parserModel as GameParserModel).getCascadeAccumulatedWin(), false, true);
      }
      dispatcher.fireEvent(eventDispatchers.STAGE_CLICK_ON_CASCADE);
    } else {
      super.onForceStopWinTickUp();
    }
  }

   // Overrided to blank function in case of cascade
   protected tickUpComplete(): void {
    if ((ingenuity.parserModel as GameParserModel).getCascadingStatus()) {
       //
    } else {
      super.tickUpComplete();
    }
  }

  // Overrided to add cascade win amount for tickup
  protected onStartWinTickUp(evt: any): void {
    let _a, _b;
    this.showWinTickUpMeter();
    if ((ingenuity.parserModel as GameParserModel).getCascadingCount() !== 0) {
      (_b = this.winValueMeterFg) === null || _b === void 0
        ? void 0
        : _b.startTick(
          (ingenuity.parserModel as GameParserModel).getCascadeAccumulatedWin(),
          this.model.getIsCredits(),
          false,
          this.model.getWinMeterTickUpDurationFg(),
          true,
          this.tickUpComplete.bind(this)
        );
      dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, { id: this.model.getWinMeterTickUpSoundFg() });
    } else if (this.model.getIsFgBigWin()) {
        (_a = this.winValueMeterFg) === null || _a === void 0
          ? void 0
          : _a.startTick(
              this.model.getThresholdBigWinAmount(),
              this.model.getIsCredits(),
              false,
              SlotConstantsBehavior.WINTICKUP_FG_3_NORMAL_TICK,
              true,
              this.tickUpComplete.bind(this)
            );
        dispatcher.fireEvent(SlotEventConstantsBehavior.PLAY_GAME_SOUND, {
          id: this.model.getWinMeterTickUpSoundFg(),
          vol: 1,
          loop: false,
        });
      }
    this.fadeFreeGameBGM();
  }
 
}
